import FullScreenLoading from "@/components/ui/fullScreenLoading";
import { Toaster } from "@/components/ui/toaster";
import { TaskProvider } from "@/contexts/BackgroundCreateDeployApp";
import { ApolloProvider } from "@/lib/apollo/ApolloProvider";
import { useUpdateUnleashContext } from "@/lib/unleash/updateContext";
import { useAuth0 } from "@auth0/auth0-react";
import { Outlet, createRootRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { TanStackRouterDevtools } from "../lib/tanstack-router/routerDevTools";
import Page404 from "./-components/-page404";
import RootError from "./-components/-root_error";

export const Route = createRootRoute({
  component: Root,
  notFoundComponent: Page404
});

export function Root() {
  const { isLoading, error, user } = useAuth0();
  useUpdateUnleashContext({ user });

  if (error) {
    return <RootError error={error} />;
  }

  if (isLoading) return <FullScreenLoading data-testid="appLoading" />;

  return (
    <ApolloProvider>
      <TaskProvider>
        <div className="dark:bg-black bg-brand-gray-100 min-h-screen w-full flex">
          <Outlet />
          <Suspense
            fallback={
              <div className="absolute bottom-0 right-0">Loading devtools</div>
            }
          >
            <TanStackRouterDevtools position="bottom-right" />
          </Suspense>
          <Toaster />
        </div>
      </TaskProvider>
    </ApolloProvider>
  );
}
